<template>
  <div class="chat-item">
    <!-- 问候语 猜你想问的回复-->
    <div class="user" v-if="chatItme.type === 4 || chatItme.type === 6">
      <div class="user-info-box" style="justify-content: flex-start;">
        <div class="imgbox">
          <img :src="robotConfig.aiIcon" alt="">
        </div>
        <div class="msgbox" style="margin-left: 7px; display: flex;white-space: pre-wrap;" v-if="chatItme.type === 4">
          <span>{{ chatItme.msg }}</span>
        </div>
        <div class="msgbox msgbox2" style="margin-left: 7px; display: flex;" v-if="chatItme.type === 6" @click="openUrl(chatItme)">
          点击查看回答
        </div>
      </div>
      <div class="bottom-btn" v-if="chatItme.quizId">
        <!-- <div class="bottom-btn"> -->
        <div class="btn-box" @click="clickBtn(1)" v-if="chatItme.activeNum === 0" style="margin-left: 0;">
          <img src="@/assets/live.svg" alt="">
          <div class="text-box">已解决</div>
        </div>
        <div class="btn-box" @click="clickBtn(0)" v-if="chatItme.activeNum === 0">
          <img src="@/assets/die.svg" alt="">
          <div class="text-box">未解决</div>
        </div>
        <div class="btn-box3 btn-box1" v-if="chatItme.activeNum === 1">
          <div class="icon-box">
            <img src="@/assets/live2.svg" alt="">
          </div>
          <div class="text-box">已解决</div>
        </div>
        <div class="btn-box3 btn-box2" v-if="chatItme.activeNum === 2">
          <div class="icon-box">
            <img src="@/assets/die2.svg" alt="">
          </div>
          <div class="text-box">未解决</div>
        </div>
      </div>
    </div>
    <!-- 用户发言 -->
    <div class="user" v-if="chatItme.type === 1">
      <div class="user-info-box">
        <div class="msgbox" style="background: #008CFE; color: #FFFFFF; margin-right: 8px; display: flex;">
          {{ chatItme.msg }}
          <!-- <div class="triangle"></div> -->
        </div>
        <div class="imgbox">
          <img src="img/studentIcon.png" alt="">
        </div>
      </div>
    </div>
    <!-- 问答与服务 -->
    <div class="system" v-if="chatItme.type === 2">
      <div class="user-info-box" style="justify-content: flex-start; margin-bottom: 16px;">
        <div class="imgbox">
          <img :src="robotConfig.aiIcon" alt="">
        </div>
        <div class="msgbox" style="margin-left: 7px; padding: 16px 8px;">
          <div class="title">
            请选择您想了解的问题
          </div>
          <div class="container">
            <ul>
              <li v-for="(item, index) in chatItme.resultList" :key="index" @click="toDetails(item)">
                {{ validText(item) }} <span v-html="item.title"></span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!-- 无法理解提问 resultList长度为 0 -->
    <div class="system" v-if="chatItme.type === 3">
      <div class="user-info-box" style="justify-content: flex-start; margin-bottom: 16px;">
        <div class="imgbox">
          <img :src="robotConfig.aiIcon" alt="">
        </div>
        <div class="msgbox" style="margin-left: 7px;">
          {{ chatItme.noResultMsg }}
        </div>
      </div>
      <!-- <div class="title">{{ chatItme.noResultMsg }}</div> -->
    </div>
    <!-- 常见问题 -->
    <issue-bar v-if="chatItme.type === 5" :list="chatItme.msg" title="常见问题" @allIssue="allIssue" @clickList="clickList"
      :robotConfig="robotConfig"></issue-bar>
  </div>
</template>

<script>
export default {
  props: {
    chatItme: {
      type: Object,
    },
    // 机器人配置
    robotConfig: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
    }
  },
  methods: {
    toDetails(item) {
      console.log(1111111111111)
      this.$emit('toDetails', item)
    },
    // 点击是否解决
    async clickBtn(num) {
      console.log('chatItme', this.chatItme)
      const res = await this.$store.dispatch('aiquestionIsSolve', {
        quizId: this.chatItme.quizId,
        isSolve: num
      })
      if (res.data.status === 1000) {
        if (num === 0) {
          this.chatItme.activeNum = 2
        } else {
          this.chatItme.activeNum = 1
        }
      } else {
        const toast = this.$createToast({
          txt: msg,
          time: 2000,
          type: 'error',
        })
        toast.show()
      }
    },
    // 全部问题
    allIssue() {
      this.$router.push({ name: 'allIssue' });
    },
    clickList(item) {
      this.$emit('clickList', item)
    },
    validText (item) {
      console.log(item)
      switch(item.type) {
        case 1:
          return '【问题】';
        case 2:
          return '【服务】';
        case 3:
          return '【办事指南】';
      }
    },
    openUrl (item) {
      console.log(this.environment.isFengChao, item)
      if (this.environment.isFengChao) {
        this.$cjc.openNewWebView({
          'url': item.msg,
          'title': item.msg,
          'hiddenNavigation': false
        })
      } else {
        window.open(item.msg);
      }
    },
  }
}
</script>

<style lang="scss">
.chat-item {
  margin: 12px 0;

  .user {
    width: 100%;
    overflow: hidden;
  }

  .user-info-box {
    width: 100%;
    float: right;
    display: flex;
    align-items: flex-start;
    justify-content: flex-end;

    .msgbox {
      max-width: calc(100vw - 120px);
      word-break: break-all;
      word-wrap: break-word;
      overflow-wrap: break-word;
      position: relative;
      padding: 12px;
      border-radius: 10px;
      font-size: 14px;
      background: #FFFFFF;
      color: #1A1A1A;
      min-height: 44px;
      align-items: center;
      line-height: 20px;
      word-wrap: break-word;
      font-family: PingFangSC, PingFang SC;

      // white-space: pre-wrap;
      .triangle {
        position: absolute;
        right: -5px;
        top: 7px;
        width: 0px;
        height: 0px;
        background: #40A9FF;
        border-top: 5px solid #F6F6F6;
        border-right: 0px;
        border-bottom: 5px solid #F6F6F6;
        border-left: 5px solid #40A9FF;
      }

      .triangle-left {
        position: absolute;
        left: -5px;
        top: 7px;
        width: 0px;
        height: 0px;
        background: #40A9FF;
        border-top: 5px solid #F6F6F6;
        border-left: 0px;
        border-bottom: 5px solid #F6F6F6;
        border-right: 5px solid #40A9FF;
      }
    }

    .msgbox2{
      color: #008CFF;
      cursor: pointer;
    }

    .imgbox {
      overflow: hidden;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      text-align: center;

      img {
        object-fit: cover;
        width: 100%;
      }
    }
  }

  .bottom-btn {
    display: flex;
    align-items: center;
    width: 100%;
    // position: absolute;
    // bottom: -10px;
    padding: 8px 0 0 47px;

    .btn-box {
      width: 75px;
      height: 28px;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #fff;
      border-radius: 4px;
      margin-left: 8px;

      img {
        width: 14px;
        height: 14px;
        margin-right: 5px;
      }

      .text-box {
        font-size: 13px;
        color: #6D7073;
        text-align: center;
        line-height: 28px;
      }
    }

    .btn-box3 {
      // width: 83px;
      // height: 28px;
      display: flex;

      .icon-box {
        width: 28px;
        height: 28px;
        border-radius: 4px 0 0 4px;
        display: flex;
        justify-content: center;
        align-items: center;

        img {
          width: 14px;
          height: 14px;
        }
      }

      .text-box {
        width: 55px;
        font-size: 13px;
        color: #6D7073;
        text-align: center;
        line-height: 28px;
        border-radius: 0 4px 4px 0;
        background-color: #FFFFFF;
      }
    }

    .btn-box1 {
      .icon-box {
        background-color: #33CC99;
      }

      .text-box {
        color: #33CC99;
      }
    }

    .btn-box2 {
      .icon-box {
        background-color: #FF8446;
      }

      .text-box {
        color: #FF8446;
      }
    }
  }

  .system {
    width: calc(100% - 30px);
    background: #ffffff;
    margin: 16px 0;
    border-radius: 5px;
    // padding: 0 15px;

    .title {
      font-size: 15px;
      color: #1A1A1A;
      font-weight: bold;
      margin-bottom: 14px;

      .blue-line {
        margin-right: 5px;
        vertical-align: baseline;
        display: inline-block;
        width: 3px;
        height: 12px;
        border-radius: 10px;
        background-color: #3296FA;
      }

      .more {
        font-size: 13px;
        float: right;
        color: #3296FA;

        img {
          width: 16px;
          height: 16px;
          position: relative;
          top: 2px;
        }
      }
    }

    .container {
      ul {
        li {
          margin-bottom: 8px;
          font-size: 14px;
          color: #1A1A1A;
          line-height: 20px;
          word-wrap: break-word;
          word-break: break-all;
        }

        li:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
}</style>